import gql from 'graphql-tag';

const FILTERED_AUCTIONS_QUERY = gql`
  query filteredAuctions(
    $filters: [Filter!]
    $savedSearchIds: [Int!]
    $size: Int!
    $sort: Sort
  ) {
    filteredAuctions(
      filters: $filters
      savedSearchIds: $savedSearchIds
      size: $size
      sort: $sort
    ) {
      ...AuctionFragment
    }
  }
`;

export default FILTERED_AUCTIONS_QUERY;
